import { render, staticRenderFns } from "./ColumnCharts.vue?vue&type=template&id=24d5a978&scoped=true"
import script from "./ColumnCharts.vue?vue&type=script&lang=js"
export * from "./ColumnCharts.vue?vue&type=script&lang=js"
import style0 from "./ColumnCharts.vue?vue&type=style&index=0&id=24d5a978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5a978",
  null
  
)

export default component.exports